module.exports = __webpack_public_path__ + "static/media/eppan.363677c6.png";